/* custom code start */
if (!customElements.get('occ-cart-gift')) {
  class OccCartGift extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('.occ-cart-gift__toggle');
      this.content = this.querySelector('.occ-cart-gift__content');
      this.radios = this.querySelectorAll('.occ-cart-gift__radio');
      this.addButton = this.querySelector('.occ-cart-gift__add-button');
      this.actions = this.querySelector('.occ-cart-gift__actions');
      this.statusText = this.querySelector('.occ-cart-gift__status-text');
      this.textarea = this.querySelector('.occ-cart-gift__textarea');
      this.charCount = this.querySelector('.occ-cart-gift__char-remaining');
      this.noteStatus = this.querySelector('.occ-cart-gift__note-status');
      this.detailToggles = this.querySelectorAll('.occ-cart-gift__details-toggle');

      this.selectedVariantId = null;
      this.giftInCart = this.dataset.giftInCart === 'true';
      this.maxChars = parseInt(this.dataset.maxChars || '250', 10);
      this.debounceTimer = null;
      this.lastSavedNote = this.textarea ? this.textarea.value : '';

      this.giftProductIds = Array.from(this.radios)
        .map((radio) => parseInt(radio.dataset.productId, 10))
        .filter((id) => !Number.isNaN(id));

      this.bindEvents();
      this.initPairedLayout();
    }

    connectedCallback() {
      if (this.sanitizeNoteInput()) {
        this.saveNoteImmediately();
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate(event);
        });
      }
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    bindEvents() {
      if (this.toggle) {
        this.toggle.addEventListener('click', this.handleToggle.bind(this));
      }

      this.radios.forEach((radio) => {
        radio.addEventListener('change', this.handleSelection.bind(this));
      });

      if (this.addButton) {
        this.addButton.addEventListener('click', this.handleAddToCart.bind(this));
      }

      if (this.textarea) {
        this.textarea.addEventListener('input', this.handleNoteInput.bind(this));
        this.textarea.addEventListener('compositionstart', () => clearTimeout(this.debounceTimer));
        this.textarea.addEventListener('compositionend', this.handleNoteInput.bind(this));
        this.textarea.addEventListener('blur', this.saveNoteImmediately.bind(this));
        this.updateCharCount();
      }

      this.detailToggles.forEach((btn) => {
        btn.addEventListener('click', this.handleDetailsToggle.bind(this));
      });

      this.querySelectorAll('.occ-cart-gift__card').forEach((card) => {
        card.addEventListener('click', this.handleCardClick.bind(this));
      });
    }

    handleToggle() {
      const isCollapsed = this.classList.toggle('is-collapsed');
      this.toggle.setAttribute('aria-expanded', !isCollapsed);
    }

    handleSelection(event) {
      this.selectedVariantId = event.target.value;
      if (this.addButton) {
        this.addButton.disabled = false;
      }
      this.clearStatus();
    }

    onCartUpdate(event) {
      if (event && event.cartData) {
        this.applyCartState(event.cartData);
        return;
      }

      fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.json())
        .then((cartData) => this.applyCartState(cartData))
        .catch(() => {});
    }

    applyCartState(cartData) {
      if (!cartData || !Array.isArray(cartData.items)) return;

      const inCartItem = cartData.items.find((item) => this.giftProductIds.includes(item.product_id));
      const inCartProductId = inCartItem ? inCartItem.product_id : null;
      const wasGiftInCart = this.giftInCart;
      this.giftInCart = inCartProductId !== null;

      this.radios.forEach((radio) => {
        const productId = parseInt(radio.dataset.productId, 10);
        const isThisInCart = this.giftInCart && productId === inCartProductId;

        radio.disabled = this.giftInCart;
        radio.checked = isThisInCart;

        const option = radio.closest('.occ-cart-gift__option');
        const badge = option ? option.querySelector('.occ-cart-gift__in-cart-badge') : null;
        if (badge) badge.hidden = !isThisInCart;
      });

      if (this.actions) {
        this.actions.classList.toggle('is-hidden', this.giftInCart);
      }

      this.selectedVariantId = null;
      if (this.addButton) {
        this.addButton.disabled = true;
        this.addButton.classList.remove('is-loading');
      }

      if (wasGiftInCart && !this.giftInCart) {
        this.clearStatus();
      }
    }

    handleCardClick(event) {
      const card = event.currentTarget;
      const option = card.closest('.occ-cart-gift__option');
      if (!option) return;

      const radio = option.querySelector('.occ-cart-gift__radio');
      if (radio && !radio.disabled && !event.target.closest('.occ-cart-gift__details-toggle')) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    handleDetailsToggle(event) {
      event.stopPropagation();
      const btn = event.currentTarget;
      const section = btn.closest('.occ-cart-gift__details-section');
      if (!section) return;

      const textEl = section.querySelector('.occ-cart-gift__details-text');
      if (!textEl) return;

      const isHidden = textEl.hasAttribute('hidden');
      if (isHidden) {
        textEl.removeAttribute('hidden');
        btn.textContent = btn.dataset.hideText;
      } else {
        textEl.setAttribute('hidden', '');
        btn.textContent = btn.dataset.showText;
      }
    }

    handleAddToCart() {
      if (!this.selectedVariantId || this.addButton.classList.contains('is-loading')) return;

      this.addButton.classList.add('is-loading');
      this.addButton.disabled = true;
      this.clearStatus();

      this.verifyGiftNotInCart()
        .then((cartData) => {
          if (cartData && Array.isArray(cartData.items)) {
            const giftAlreadyInCart = cartData.items.some((item) =>
              this.giftProductIds.includes(item.product_id)
            );
            if (giftAlreadyInCart) {
              this.applyCartState(cartData);
              this.showStatus('Sepetinizde zaten bir hediye kutusu var.', 'error');
              return;
            }
          }

          this.addGiftToCart();
        })
        .catch(() => {
          this.addGiftToCart();
        });
    }

    verifyGiftNotInCart() {
      return fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { Accept: 'application/json' },
      }).then((response) => response.json());
    }

    addGiftToCart() {
      const body = JSON.stringify({
        id: parseInt(this.selectedVariantId),
        quantity: 1,
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
      })
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        })
        .then(() => {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'occ-cart-gift' });
          }

          this.saveNoteImmediately();
          this.showStatus('Hediye kutusu sepete eklendi!', 'success');

          setTimeout(() => {
            window.location.reload();
          }, 600);
        })
        .catch(() => {
          this.showStatus('Bir hata oluştu. Lütfen tekrar deneyin.', 'error');
          this.addButton.classList.remove('is-loading');
          this.addButton.disabled = false;
        });
    }

    /* --- Gift message / order note --- */

    sanitizeNoteInput() {
      if (!this.textarea) return false;

      const value = this.textarea.value;
      const selectionStart = this.textarea.selectionStart;
      const selectionEnd = this.textarea.selectionEnd;
      const selectionDirection = this.textarea.selectionDirection;
      let removedBeforeStart = 0;
      let removedBeforeEnd = 0;
      const emojiPattern = /[#*0-9]\uFE0F?\u20E3|[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}][\uFE0E\uFE0F\p{Emoji_Modifier}\u{E0020}-\u{E007F}]*(?:\u200D[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}][\uFE0E\uFE0F\p{Emoji_Modifier}\u{E0020}-\u{E007F}]*)*\u200D*|[\uD800-\uDFFF]/gu;
      const cleanValue = value.replace(emojiPattern, (match, offset) => {
        removedBeforeStart += Math.max(0, Math.min(selectionStart - offset, match.length));
        removedBeforeEnd += Math.max(0, Math.min(selectionEnd - offset, match.length));
        return '';
      });

      if (cleanValue === value) return false;

      this.textarea.value = cleanValue;
      this.textarea.setSelectionRange(
        selectionStart - removedBeforeStart,
        selectionEnd - removedBeforeEnd,
        selectionDirection
      );
      this.updateCharCount();
      this.showNoteStatus('Hediye notunda emoji kullanılamaz. Emojiler kaldırıldı.');
      return true;
    }

    handleNoteInput(event) {
      if (event && event.isComposing) return;

      this.sanitizeNoteInput();

      if (this.textarea.value.length > this.maxChars) {
        this.textarea.value = this.textarea.value.substring(0, this.maxChars);
      }
      this.updateCharCount();

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.saveNote();
      }, 800);
    }

    updateCharCount() {
      if (!this.charCount) return;
      const remaining = this.maxChars - (this.textarea ? this.textarea.value.length : 0);
      this.charCount.textContent = remaining;

      const wrapper = this.charCount.closest('.occ-cart-gift__char-count');
      if (wrapper) {
        wrapper.classList.toggle('is-limit', remaining <= 0);
      }
    }

    saveNoteImmediately() {
      clearTimeout(this.debounceTimer);
      this.saveNote();
    }

    saveNote() {
      if (!this.textarea) return;

      this.sanitizeNoteInput();
      const noteValue = this.textarea.value.trim();
      if (noteValue === this.lastSavedNote) return;

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: noteValue }),
      })
        .then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.json();
        })
        .then(() => {
          this.lastSavedNote = noteValue;
          const message = this.noteStatus && this.noteStatus.textContent.includes('Emojiler kaldırıldı.')
            ? 'Kaydedildi. Emojiler kaldırıldı.'
            : 'Kaydedildi';
          this.showNoteStatus(message);
        })
        .catch(() => {
          this.showNoteStatus('Kaydetme başarısız');
        });
    }

    showNoteStatus(message) {
      if (!this.noteStatus) return;
      clearTimeout(this.noteStatusTimer);
      this.noteStatus.textContent = message;
      this.noteStatusTimer = setTimeout(() => {
        if (this.noteStatus) this.noteStatus.textContent = '';
      }, 2000);
    }

    /* --- Status messages --- */

    showStatus(message, type) {
      if (!this.statusText) return;
      this.statusText.textContent = message;
      this.statusText.className = 'occ-cart-gift__status-text';
      if (type) this.statusText.classList.add(`is-${type}`);
    }

    clearStatus() {
      if (!this.statusText) return;
      this.statusText.textContent = '';
      this.statusText.className = 'occ-cart-gift__status-text';
    }

    /* --- Paired layout with cart-samples --- */

    initPairedLayout() {
      const samplesEl = document.querySelector('#shopify-section-cart-samples .occ-cart-samples');
      if (!samplesEl) return;

      const giftWrapper = this.closest('.shopify-section');
      const samplesWrapper = samplesEl.closest('.shopify-section');

      if (giftWrapper && samplesWrapper) {
        giftWrapper.classList.add('occ-cart-extras--paired');
        samplesWrapper.classList.add('occ-cart-extras--paired');
      }
    }
  }

  customElements.define('occ-cart-gift', OccCartGift);
}
/* custom code end */
